"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var AuthenticationContext_1 = tslib_1.__importDefault(require("./AuthenticationContext"));
function OAuthCallbackRoute() {
    var _a = react_1.useContext(AuthenticationContext_1["default"]), fetchToken = _a.fetchToken, callbackPath = _a.callbackPath, setError = _a.setError;
    var location = react_router_dom_1.useLocation();
    var history = react_router_dom_1.useHistory();
    react_1.useEffect(function () {
        if (location.pathname !== callbackPath)
            return;
        function completeLogin(code, state) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetchToken(code)];
                        case 1:
                            if (_a.sent())
                                history.replace(decodeURIComponent(state));
                            return [2 /*return*/];
                    }
                });
            });
        }
        var successRedirectPathRegex = /\?code=(\S+)&state=(.+)/;
        var errorRedirectPathRegex = /\?error=(\S+)&error_description=(.+)&state=(.+)/;
        var successPathMatch = location.search.match(successRedirectPathRegex);
        if (successPathMatch) {
            var code = successPathMatch[1], state = successPathMatch[2];
            completeLogin(code, decodeURIComponent(state));
        }
        var errorRedirectPathMatch = location.search.match(errorRedirectPathRegex);
        if (errorRedirectPathMatch) {
            var error = errorRedirectPathMatch[1], errorDescription = errorRedirectPathMatch[2];
            setError(error + " - " + decodeURIComponent(errorDescription));
        }
    }, [fetchToken, history, location, callbackPath, setError]);
    return null;
}
exports["default"] = OAuthCallbackRoute;
//# sourceMappingURL=OAuthCallbackRoute.js.map